import { cn } from '../../lib/cn';

interface SpinnerProps {
  tamanho?: 'sm' | 'md' | 'lg';
  className?: string;
}

const TAMANHOS: Record<NonNullable<SpinnerProps['tamanho']>, string> = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-10 w-10 border-[3px]',
};

export function Spinner({ tamanho = 'md', className }: SpinnerProps) {
  return (
    <span
      className={cn(
        'inline-block animate-spin rounded-full border-current border-t-transparent text-institutional',
        TAMANHOS[tamanho],
        className,
      )}
      aria-label="Carregando"
    />
  );
}
